import { render, staticRenderFns } from "./MotorBikeRightHandlebar.vue?vue&type=template&id=3c78a6f0"
import script from "./MotorBikeRightHandlebar.vue?vue&type=script&lang=js"
export * from "./MotorBikeRightHandlebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports